const constants = {
  loading: false,
  done: false,
  error: '',
};

export default constants;
